const PageShimmer = () => {
  return (
    <div className="w-full p-6 space-y-6 animate-pulse">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-7 w-7 bg-gray-200/70 rounded-lg" />
          <div className="h-6 w-44 bg-gray-200/70 rounded-lg" />
        </div>
        <div className="flex gap-3">
          <div className="h-9 w-24 bg-gray-200/50 rounded-lg border border-gray-200" />
          <div className="h-9 w-32 bg-gray-200/50 rounded-lg border border-gray-200" />
        </div>
      </div>

      {/* Form card */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-5">
        {/* Section title */}
        <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
          <div className="h-5 w-5 bg-gray-200/60 rounded" />
          <div className="h-5 w-40 bg-gray-200/70 rounded" />
        </div>

        {/* Form fields grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="space-y-2">
              <div className="h-3.5 w-24 bg-gray-200/60 rounded" />
              <div className="h-10 w-full bg-gray-100/80 rounded-lg border border-gray-200" />
            </div>
          ))}
        </div>

        {/* Second section */}
        <div className="flex items-center gap-2 pb-3 border-b border-gray-100 pt-3">
          <div className="h-5 w-5 bg-gray-200/60 rounded" />
          <div className="h-5 w-48 bg-gray-200/70 rounded" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="space-y-2">
              <div className="h-3.5 w-28 bg-gray-200/60 rounded" />
              <div className="h-10 w-full bg-gray-100/80 rounded-lg border border-gray-200" />
            </div>
          ))}
        </div>

        {/* Action buttons */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
          <div className="h-10 w-24 bg-gray-200/50 rounded-lg" />
          <div className="h-10 w-32 bg-gray-200/70 rounded-lg" />
        </div>
      </div>
    </div>
  );
};

export default PageShimmer;
